const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Posaotoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinarasema",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obavezno",
    },
  },
  salutation: {
    label: "Oslovljavanje",
    placeholder: "Odaberite oslovljavanje",
    errors: {
      required: "Oslovljavanje je obavezno",
      invalid: "Molimo odaberite važeće oslovljavanje",
    },
  },
  firstName: {
    label: "Ime",
    placeholder: "Ivan",
    errors: {
      required: "Ime je obavezno",
      minLength: "Ime mora imati najmanje 2 znaka",
      maxLength: "Ime može imati najviše 50 znakova",
    },
  },
  lastName: {
    label: "Prezime",
    placeholder: "Horvat",
    errors: {
      required: "Prezime je obavezno",
      minLength: "Prezime mora imati najmanje 2 znaka",
      maxLength: "Prezime može imati najviše 50 znakova",
    },
  },
  email: {
    label: "E-pošta",
    placeholder: "ivan.horvat@primjer.hr",
    description: "Molimo unesite osobnu e-poštu, a ne dijeljenu e-poštu.",
    prefixWarningTitle: "Otkriven dijeljeni poštanski sandučić",
    prefixWarningDescription:
      "Preporučujemo korištenje osobne e-pošte za bolje personalizirano iskustvo",
    errors: {
      required: "E-pošta je obavezno",
      invalidEmail: "Molimo unesite važeću e-poštu",
      emailAssociatedWithYourAccount:
        "Vaša e-pošta povezana je s vašim računom i ne može se promijeniti.",
    },
  },
  confirmEmail: {
    label: "Potvrdite e-poštu",
    placeholder: "ivan.horvat@primjer.hr",
    errors: {
      required: "Potvrda e-pošte je obavezna",
      invalidEmail: "Molimo unesite važeću e-poštu",
      emailMatchError: "E-pošte se ne podudaraju",
    },
  },
  password: {
    label: "Lozinka",
    placeholder: "Unesite svoju lozinku",
    errors: {
      required: "Lozinka je obavezna",
    },
  },
  confirmPassword: {
    label: "Potvrdite lozinku",
    placeholder: "Potvrdite svoju lozinku",
    errors: {
      required: "Potvrda lozinke je obavezna",
      passwordMatchError: "Lozinke se ne podudaraju",
    },
  },
  addressLine1: {
    label: "Adresa linija 1",
    placeholder: "Ilica 123",
    errors: {
      required: "Adresa linija 1 je obavezna",
      minLength: "Adresa linija 1 mora imati najmanje 5 znakova",
      maxLength: "Adresa linija 1 može imati najviše 100 znakova",
    },
  },
  addressLine2: {
    label: "Adresa linija 2",
    placeholder: "Stan 4B",
    errors: {
      required: "Adresa linija 2 je obavezna",
      maxLength: "Adresa linija 2 može imati najviše 100 znakova",
    },
  },
  city: {
    label: "Grad",
    placeholder: "Zagreb",
    errors: {
      required: "Grad je obavezan",
      minLength: "Grad mora imati najmanje 2 znaka",
      maxLength: "Grad može imati najviše 50 znakova",
    },
  },
  state: {
    label: "Država",
    placeholder: "Odaberite državu",
    errors: {
      required: "Država je obavezna",
      invalid: "Molimo odaberite važeću državu",
    },
  },
  jurisdiction: {
    label: "Nadlekažnost licence",
    placeholder: "Odaberite nadlekažnost licence",
    errors: {
      required: "Nadlekažnost licence je obavezna",
      invalid: "Molimo odaberite važeću nadlekažnost",
    },
  },
  zipCode: {
    label: "Poštanski broj",
    placeholder: "10000",
    errors: {
      required: "Poštanski broj je obavezan",
      invalid: "Molimo unesite važeći poštanski broj",
    },
  },
  role: {
    label: "Uloga",
    placeholder: "Odaberite svoju ulogu",
    errors: {
      required: "Molimo odaberite svoju ulogu",
      invalid: "Molimo odaberite važeću ulogu",
    },
  },
  businessType: {
    label: "Vrsta poslovanja",
    placeholder: "Odaberite vrstu poslovanja",
    errors: {
      required: "Vrsta poslovanja je obavezna",
      invalid: "Molimo odaberite važeću vrstu poslovanja",
    },
  },
  businessName: {
    label: "Naziv tvrtke",
    placeholder: "Unesite naziv tvrtke",
    errors: {
      required: "Naziv tvrtke je obavezan",
      minLength: "Naziv tvrtke mora imati najmanje 2 znaka",
      maxLength: "Naziv tvrtke može imati najviše 100 znakova",
    },
  },
  businessSearch: {
    label: "Pretraga tvrtke:",
    addNewAccount: "Dodaj novi poslovni račun",
    canNotFindBusiness: "Ne možete pronaći svoju tvrtku?",
    guideline:
      "Molimo unesite svoj poštanski broj i zatim odaberite s popisa ispod.",
    guidelineForNameSearch:
      "Molimo unesite puni naziv tvrtke i zatim odaberite s popisa.",
    placeholder: "Gdje radite?",
    noResults: "Nema rezultata",
    searching: "Pretraživanje...",
    selectedBusinessHeading: "Odabrana tvrtka:",
    selectedBusinessNotCorrect: "Nije točno?",
    selectedBusinessTryAgain: "Pokušajte ponovno",
    selectedBusinessDismiss: "Odbaci tvrtku",
    resultsFound: {
      singular: "Pronađena 1 tvrtka",
      plural: "Pronađeno više tvrtki",
    },
    errors: {
      network:
        "Imamo problema s povezivanjem na uslugu pretrage tvrtki. Molimo pokušajte ponovno kasnije.",
    },
  },
  explicitConsent: {
    label:
      "Označavanjem ovog okvira prihvaćam Elanco Uvjete korištenja i potvrđujem da će Elanco prikupljati i obrađivati moje osobne podatke u skladu s Elanco Pravilima privatnosti",
    errors: {
      required: "E-pošta pristanak je obavezan",
    },
  },
  explicitSmsConsent: {
    label:
      "Označavanjem ovog okvira pristajem primati marketinške komunikacije od tvrtke Elanco putem SMS-a/tekstualne poruke.",
    errors: {
      required: "Privola za SMS je obavezna",
    },
  },
  telephone: {
    label: "Osobni telefon",
    placeholder: "Unesite svoj osobni telefonski broj",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Pretraži državu…",
    errors: {
      invalid: "Molimo unesite važeći telefonski broj.",
    },
  },
  businessTelephone: {
    label: "Poslovni telefon",
    placeholder: "Unesite poslovni telefonski broj",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Pretraži državu…",
    errors: {
      invalid: "Molimo unesite važeći telefonski broj.",
    },
  },
  professionalNumber: {
    label: "Profesionalni broj",
    placeholder: "1234567",
    errors: {
      required: "Molimo unesite profesionalni broj",
      maxLength: "Unos prela zi ograničenje znakova",
    },
  },
  addressSearch: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  businessSearchField: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  checkbox: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  combobox: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  datePicker: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  dateRange: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  dateTime: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  emailField: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  fileInput: {
    errors: {
      required: "Molimo odaberite datoteku",
    },
  },
  number: {
    errors: {
      required: "Molimo unesite broj",
      minValue: "Molimo unesite vrijednost veću od minimalne",
      maxValue: "Molimo unesite vrijednost manju od maksimalne",
    },
  },
  passwordField: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  rangeSlider: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  select: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  telephoneField: {
    errors: {
      required: "Molimo unesite samo brojeve",
      invalidTelephone: "Molimo unesite važeći telefonski broj",
      invalidFormat: "Nevažeći format broja",
    },
  },
  text: {
    errors: {
      required:
        "Molimo koristite samo slova (A-Z), brojeve (0-9) i bez simbola",
      maxLength: "Unos prela zi ograničenje znakova",
      minLength: "Unos mora imati najmanje 2 znaka",
    },
  },
  textarea: {
    characters: "merkkiä",
  },
  time: {
    errors: {
      required: "Ovo polje je obavezno",
    },
  },
  form: {
    errors: {
      generic:
        "Došlo je do pogreške prilikom slanja obrasca. Molimo pokušajte ponovno.",
      reportAnIssue: "Molimo prijavite problem.",
      configuration: "Pogreška konfiguracije",
      noFormQuestionsAvailable: "Pitanja obrasca nisu dostupna.",
      formComponentLoad:
        "Komponenta obrasca nije se mogla učitati zbog nepodražavnog polja.",
      code: "Kod",
      type: "Vrsta",
      missingRequiredFields:
        "Ovom obrascu nedostaju obavezna polja (E-pošta i/ili Pristanak). Molimo kontaktirajte administratora da ispravi konfiguraciju obrasca.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Veterinar",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Proizvođač - mješoviti/ostalo",
    id: "producer_mixed_other",
  },
  {
    value: "Retailer",
    label: "Trgovac na malo",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Uzgajivač ovaca",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinar",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Veterinar", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinar, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinaravustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinarasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinarasema - Veterinar",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinarasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinarasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinar",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Gospodin",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Gospodin",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Gospođa",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Gospođa/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
